import React, { useContext, useEffect, useState } from "react";
import {
  calculatePayableAmount,
  calculateStayDuration,
  changeCleaningStatus,
  formatTimeToAMPM,
  getEditGuest,
  getRoom,
  guestDataToupdate,
} from "../utils/helperFunctions";
// import { useNavigate } from "react-router-dom";
import { Mycontext } from "../context/context";
import CheckoutModal from "../components/CheckoutModal";
// import ExtensionWatcher from "../components/ExtensionWatcher";
// import ExtensionModel from "../components/ExtensionModel";
import { motion } from "framer-motion";
import GuestAndCheckInForm from "../components/GuestAndCheckInForm";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { toast } from "react-toastify";

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Roomstatus = ({ role }) => {
  const [rooms, setRooms] = useState([]);
  const { checkExtension, formToShow, checkOutData, setCheckOutData } =
    useContext(Mycontext);
  const [totals, setTotals] = useState({
    todayTotalAmount: 0,
    monthTotalAmount: 0,
  });
  // const { setCheckext } = useContext(Mycontext);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [selectedRoomId, setSelectedRoomId] = useState("");
  const [chartData, setChartData] = useState([]);
  const [editvalue, setEditvalue] = useState({});
  const [isEdit, setisEdit] = useState(false);
  const [showStatsSection, setShowStatsSection] = useState(false);

  // console.log("rooms",rooms);


  useEffect(() => {
    fetchRooms();
    // const checkext = localStorage.getItem("checkext");
    // setCheckext(checkext);
  }, []);

  const handleToggleRoomStatus = async (roomId, newStatus) => {
    try {
      const response = await changeCleaningStatus(roomId, newStatus);
      if (response.data.status) {
        fetchRooms();
        toast.success(
          `Room cleaning status updated to ${newStatus ? "inactive" : "active"}`
        );
      }
    } catch (error) {
      console.error("Error updating room status:", error);
      toast.error("Failed to update room status");
    }
  };

  const handleEditClick = async (room) => {
    try {

      const response = await guestDataToupdate(room.checkInId);
      if (response.data.status) {
        setEditvalue(response.data.data);
        setisEdit(true);
        checkExtension("formA");
      }
    } catch (error) {
      console.error("Error fetching guest details:", error);
    }
  };

  const fetchRooms = async () => {
    try {
      setIsRefreshing(true);
      const response = await getRoom();

      setTotals({
        todayTotalAmount: response.todayTotalAmount,
        monthTotalAmount: response.monthTotalAmount,
      });
      setChartData(response.data);

      const currentTime = new Date();
      const sortedRooms = response.data.map((room) => {
        if (room.status === "booked" && room.checkInDate && room.checkInTime) {
          const checkInDate = new Date(room.checkInDate);
          const [hours, minutes] = room.checkInTime.split(":");
          checkInDate.setHours(parseInt(hours, 10));
          checkInDate.setMinutes(parseInt(minutes, 10));

          const stayDuration = calculateStayDuration(checkInDate, currentTime);
          const { payableHours, payableAmount } = calculatePayableAmount(
            stayDuration,
            room.gracePeriod || 0,
            room.hourlyPricing || [],
            checkInDate,
            currentTime,
            room.nightCheckInConfirmed,
            room.nightStayPrice
          );
          return {
            ...room,
            stayDuration,
            payableHours,
            payableAmount,
            shouldBlink: shouldBlink(room),
            shouldBlinkCleaning: false,
          };
        }

        return {
          ...room,
          stayDuration: "00:00",
          payableHours: 0,
          payableAmount: 0,
          shouldBlink: false,
          shouldBlinkCleaning: shouldBlinkCleaning(room)
        };
      });
      setRooms(sortedRooms);
    } catch (error) {
      console.error("Error fetching rooms:", error);
    } finally {
      setIsRefreshing(false);
    }
  };

  const handleRoomClick = (room) => {
    if (role === "view only") return null;
    if (room.status === "available" && room.roomStatus && !room.underCleaning) {
      setSelectedRoomId(room._id);
      setisEdit(false);
      checkExtension("formA");
    } else if (room.status === "booked") {
      setCheckOutData(room);
      checkExtension("formB");
    }
  };

  const getRoomStatusColor = (room) => {
    // console.log("room",room);

    if (!room.roomStatus) return "bg-amber-500";
    if (room.underCleaning) return "bg-gray-400";
    if (room.nightCheckInConfirmed) return "bg-sky-500";
    if (room.expectedCheckoutHour >= 4 || room.advancePayAmount >= 800)
      return "bg-indigo-500";
    if (room.status === "booked") return "bg-red-500";
    return "bg-emerald-500";
  };

  const formatIfNotToday = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const today = new Date();
    const format = (d) => d.toLocaleDateString("en-GB").replace(/\//g, "-");
    return format(date) !== format(today)
      ? date.toLocaleDateString("en-GB").replace(/\//g, "-")
      : "";
  };

  // Group rooms by floor number
  const groupRoomsByFloor = () => {
    const grouped = {};
    rooms.forEach((room) => {
      if (!grouped[room.floorNo]) {
        grouped[room.floorNo] = [];
      }
      grouped[room.floorNo].push(room);
    });
    return grouped;
  };

  const shouldBlink = (room) => {
    if (!room.checkInTime || !room.expectedCheckoutHour) return false;
    const [hours, minutes] = room.checkInTime.split(":").map(Number);
    const checkInDate = new Date(room.checkInDate);
    checkInDate.setHours(hours, minutes, 0, 0);
    const expectedCheckout = new Date(checkInDate);
    expectedCheckout.setHours(
      checkInDate.getHours() + room.expectedCheckoutHour
    );
    const now = new Date();
    const diffMinutes = (expectedCheckout - now) / (1000 * 60);
    return (diffMinutes > 0 && diffMinutes <= 15) || diffMinutes < 0;
  };
  const shouldBlinkCleaning = (room) => {
    if (!room.underCleaning) return false;
    const cleaningStartTime = new Date(room.cleaningStartTime);
    const now = new Date();
    const diffMinutes = (now - cleaningStartTime) / (1000 * 60);
    return (diffMinutes > 45);
  };

  const groupedRooms = groupRoomsByFloor();
  const floorNumbers = Object.keys(groupedRooms).sort((a, b) => a - b);

  // Updated chart configuration
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Hide legend for cleaner look
      },
      tooltip: {
        backgroundColor: "#ffffff",
        titleColor: "#4f46e5", // Indigo to match theme
        bodyColor: "#1f2937",
        borderColor: "#e5e7eb",
        borderWidth: 1,
        padding: 12,
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
        titleFont: {
          weight: "bold",
          size: 14,
        },
        bodyFont: {
          size: 12,
        },
        callbacks: {
          label: function (context) {
            return `Guests: ${context.raw}`;
          },
          title: function (context) {
            return `Room ${context[0].label}`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          color: "#6b7280",
          font: {
            weight: 500,
          },
        },
      },
      y: {
        grid: {
          color: "#f3f4f6",
          drawBorder: false,
        },
        ticks: {
          color: "#6b7280",
          precision: 0,
          font: {
            weight: 500,
          },
        },
        beginAtZero: true,
      },
    },
    animation: {
      duration: 1000,
      easing: "easeOutQuart",
    },
  };

  // Enhanced chart data with gradient
  const getChartData = (chartData) => {
    const ctx = document.createElement("canvas").getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, 0, 400);
    gradient.addColorStop(0, "rgba(79, 70, 229, 0.8)"); // Indigo with opacity
    // gradient.addColorStop(1, 'rgba(99, 102, 241, 0.2)'); // Lighter indigo

    return {
      labels: chartData.map((room) => room.roomNo),
      datasets: [
        {
          label: "Guest Count",
          data: chartData.map((room) => room.todayCheckInCount),
          backgroundColor: gradient,
          borderRadius: 6,
          borderSkipped: false,
          borderWidth: 0,
          barPercentage: 0.7,
          categoryPercentage: 0.8,
        },
      ],
    };
  };

  // First calculate the total check-ins
  const totalTodayCheckins = rooms.reduce(
    (sum, room) => sum + (room.todayCheckInCount || 0),
    0
  );

  return (
    <div className="p-4 md:p-6 bg-gray-50 ">
      <div className="container mx-auto bg-white rounded-xl shadow-sm overflow-hidden">
        {/* Add a toggle button at the top */}
        {role === "receptionist" &&
          (<div className="flex justify-end p-4  md:p-6 border-b border-gray-100 bg-gradient-to-r from-indigo-50 to-blue-50">
            {/* <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
              Room Status Dashboard
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              Real-time overview of all rooms
            </p>
          </div> */}
            <button
              onClick={() => setShowStatsSection(!showStatsSection)}
              className="flex items-center gap-2 px-4 py-2 bg-white text-indigo-600 border border-indigo-200 rounded-lg hover:bg-indigo-50 transition-colors shadow-sm"
            >
              {showStatsSection ? (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Hide Stats
                </>
              ) : (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Show Stats
                </>
              )}
            </button>
          </div>)}

        {/* Header and Stats Section */}
        {(showStatsSection || role === "manager") && (
          <div className="p-4 md:p-6 border-b border-gray-100 bg-gradient-to-r from-indigo-50 to-blue-50">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 gap-4">
              <div>
                <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
                  Room Status Dashboard
                </h1>
                <p className="text-sm text-gray-600 mt-1">
                  Real-time overview of all rooms
                </p>
              </div>
              <div className="flex  gap-3">
                <div>
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-emerald-500"></div>
                    <span className="text-xs">Available</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-red-500"></div>
                    <span className="text-xs">Booked</span>
                  </div>

                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-gray-400"></div>
                    <span className="text-xs">Cleaning</span>
                  </div>
                  {role === "manager" && (
                    <div className="flex items-center gap-2">
                      <div className="w-3 h-3 rounded-full bg-amber-500"></div>
                      <span className="text-xs">Inactive</span>
                    </div>
                  )}
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-indigo-500"></div>
                    <span className="text-xs">Full-Day Booking</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full bg-sky-500"></div>
                    <span className="text-xs">Night-Stay Booking</span>
                  </div>
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <p className="text-xs font-semibold">
                      C.D.:
                      <span className="text-xs font-normal">CheckIn Date</span>
                    </p>
                  </div>
                  <div className="flex items-center gap-2">
                    <p className="text-xs font-semibold">
                      E.C.:
                      <span className="text-xs font-normal">
                        Expected CheckOut
                      </span>
                    </p>
                  </div>
                  <div className="flex items-center gap-2">
                    <p className="text-xs font-semibold">
                      A.P.:
                      <span className="text-xs font-normal">Advance Pay</span>
                    </p>
                  </div>
                  <div className="flex items-center gap-2">
                    <p className="text-xs font-semibold">
                      Due:
                      <span className="text-xs font-normal">
                        Having to be paid
                      </span>
                    </p>
                  </div>
                  <div className="flex items-center gap-2">
                    <p className="text-xs font-semibold">
                      S.T.:
                      <span className="text-xs font-normal">Start Time</span>
                    </p>
                  </div>

                  <div className="flex items-center gap-2">
                    <p className="text-xs font-semibold">
                      C.T.:
                      <span className="text-xs font-normal">Current Time</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* </div> */}

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-500">
                      Today's Revenue
                    </p>
                    <p className="text-2xl font-bold text-gray-800 mt-1">
                      ₹{totals.todayTotalAmount.toLocaleString()}
                    </p>
                    <div className="flex items-center mt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-green-500"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="text-xs text-gray-500 ml-1">
                        Updated just now
                      </span>
                    </div>
                  </div>
                  <div className="bg-indigo-100 p-3 rounded-full">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-indigo-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                </div>
              </motion.div>

              {role === "manager" && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.1 }}
                  className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm"
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm font-medium text-gray-500">
                        Monthly Revenue
                      </p>
                      <p className="text-2xl font-bold text-gray-800 mt-1">
                        ₹{totals.monthTotalAmount.toLocaleString()}
                      </p>
                      <div className="flex items-center mt-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 text-blue-500"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <span className="text-xs text-gray-500 ml-1">
                          Current month
                        </span>
                      </div>
                    </div>
                    <div className="bg-blue-100 p-3 rounded-full">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                  </div>
                </motion.div>
              )}
              {/* Today's Occupancy Card */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: 0.1 }}
                className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-500">
                      Today's Occupancy
                    </p>
                    <p className="text-2xl font-bold text-gray-800 mt-1">
                      {totalTodayCheckins}
                    </p>
                    <div className="flex items-center mt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-amber-500"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="text-xs text-gray-500 ml-1">
                        {totalTodayCheckins >= 15
                          ? "Very busy day"
                          : totalTodayCheckins >= 5
                            ? "Steady flow"
                            : "Quiet day"}
                      </span>
                    </div>
                  </div>
                  <div className="bg-amber-100 p-3 rounded-full">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-amber-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                      />
                    </svg>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        )}
        {/* Rooms Grid Grouped by Floor */}
        <div className="p-4 md:p-6">
          {isRefreshing && rooms.length === 0 ? (
            <div className="flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
            </div>
          ) : rooms.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-16 w-16 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
              <p className="mt-4 text-lg font-medium text-gray-500">
                No rooms found
              </p>
            </div>
          ) : (
            <div className="space-y-8">
              {floorNumbers.map((floor) => (
                <motion.div
                  key={floor}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="bg-gray-50 rounded-xl p-4 shadow-sm"
                >
                  <div key={floor}>
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-xl font-semibold text-gray-800 flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5 mr-2 text-indigo-600"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Floor {floor}
                      </h2>
                      <span className="text-sm text-gray-500 bg-white px-3 py-1 rounded-full shadow-xs">
                        {groupedRooms[floor].length} rooms
                      </span>
                    </div>
                    <div className="grid grid-cols-2 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 gap-4">
                      {groupedRooms[floor]
                        .filter((room) =>
                          role !== "manager" ? room.roomStatus : true
                        )
                        .map((room) => (
                          <motion.div
                            key={room._id}
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.2 }}
                            onClick={(e) => {
                              // Prevent room click when clicking on the toggle
                              if (
                                !e.target.closest(".toggle-container") &&
                                !e.target.closest(".edit-icon")
                              ) {
                                handleRoomClick(room);
                              }
                            }}
                            // onClick={() => handleRoomClick(room)}
                            className={`relative rounded-xl ${room.shouldBlink || room.shouldBlinkCleaning ? "animate-pulse" : ""
                              } overflow-hidden shadow-md transition-all duration-300 h-[12.3rem] flex flex-col 
                            ${getRoomStatusColor(room)} 
                            ${role === "receptionist"
                                ? "cursor-pointer hover:shadow-lg hover:-translate-y-1"
                                : "cursor-default"
                              }
                            ${!room.roomStatus ? "opacity-80" : ""}`}
                          >
                            {/* Edit icon for booked rooms */}
                            {room.status === "booked" && (
                              <div
                                className="absolute top-0.5 left-2 z-10 bg-black bg-opacity-50 rounded-full p-1 edit-icon"
                                onClick={(e) => handleEditClick(room)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-5 w-5 text-white"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                  />
                                </svg>
                              </div>
                            )}
                            {/* <div className="text-center bg-black bg-opacity-20 text-white text-md font-bold px-2 py-1 rounded-md">
                              {room.roomNo}
                            </div> */}

                            <div className="flex justify-between items-center bg-black bg-opacity-20 text-white px-2 py-1 rounded-md relative">
                              <div className="toggle-container flex items-center absolute right-2">
                                <label className="relative inline-flex items-center cursor-pointer">
                                  <input
                                    type="checkbox"
                                    className="sr-only peer"
                                    checked={room.underCleaning}
                                    onChange={(e) =>
                                      handleToggleRoomStatus(
                                        room._id,
                                        e.target.checked
                                      )
                                    }
                                    disabled={
                                      room.status !== "available" ||
                                      role === "view only"
                                    }
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                  <div
                                    className={`w-12 h-6 rounded-full peer
                                      ${room.underCleaning
                                        ? "bg-gray-500"
                                        : "bg-gray-300"
                                      }
                                      peer-focus:outline-none 
                                      peer-checked:after:translate-x-full
                                      after:content-[''] after:absolute after:top-0.5 after:left-[3px]
                                      after:bg-white after:rounded-full after:shadow-sm
                                      after:h-5 after:w-5 after:transition-all after:duration-300
                                      flex items-center justify-between px-1`}
                                  ></div>
                                </label>
                              </div>

                              {/* Centered room number */}
                              <div className="text-md font-bold mx-auto">
                                {room.roomNo}
                              </div>
                            </div>

                            <div className="flex-1 flex flex-col items-center justify-start text-white p-1">
                              {room.status === "booked" && (
                                <>
                                  <p className="text-sm font-semibold text-center line-clamp-2">
                                    {room.guestName}
                                  </p>

                                  <div className="flex flex-col items-center">
                                    <p className="text-base opacity-90 text-center">
                                      {formatTimeToAMPM(room.checkInTime)} /{" "}
                                      {room.payableHours} hr
                                    </p>
                                    <p className="text-lg opacity-90 text-center font-semibold">
                                      {room.stayDuration && (
                                        <>
                                          C.T.:
                                          {room.stayDuration} hr
                                        </>
                                      )}
                                    </p>
                                    <p className="text-xs opacity-90 text-center">
                                      {formatIfNotToday(
                                        room.checkInDate.split("T")[0]
                                      ) && (
                                          <>
                                            C.D.:
                                            {formatIfNotToday(
                                              room.checkInDate.split("T")[0]
                                            )}
                                          </>
                                        )}
                                    </p>
                                    <p className="text-xs opacity-90 text-center">
                                      {room.expectedCheckoutHour && (
                                        <>
                                          E.C.:
                                          {room.expectedCheckoutHour} hr
                                        </>
                                      )}
                                    </p>
                                    <p className="text-xs opacity-90 text-center">
                                      {/* {room.advancePayAmount > 0 && ( */}
                                      <>
                                        A.P.:
                                        {room.advancePayAmount}₹
                                      </>
                                      {/* )} */}
                                    </p>

                                  </div>
                                </>
                              )}
                              {room.underCleaning && (
                                <>
                                  <div className="flex flex-col items-center">
                                    <p className="text-xs opacity-90 text-center">
                                      {formatIfNotToday(room.cleaningStartTime)}
                                    </p>
                                    <p className="text-base opacity-90 text-center">
                                      S.T.:
                                      {new Date(
                                        room.cleaningStartTime
                                      ).toLocaleTimeString("en-US", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                      })}
                                    </p>
                                  </div>
                                </>
                              )}
                            </div>
                            {room.status === "booked" && (
                              <div className={`flex justify-center items-center bg-black text-white px-2 py-1 rounded-md relative ${room.payableAmount - room.advancePayAmount < 0 ? "bg-opacity-20" : ""
                                }`}>
                                <div className="text-xl opacity-90 text-center font-semibold">
                                  {room.payableAmount -
                                    room.advancePayAmount >=
                                    0 ? (
                                    <>
                                      Due:
                                      {room.payableAmount -
                                        room.advancePayAmount}
                                      ₹
                                    </>
                                  ) : (
                                    <>
                                      Return:
                                      {Math.abs(
                                        room.payableAmount -
                                        room.advancePayAmount
                                      )}
                                      ₹
                                    </>
                                  )}
                                </div>
                              </div>
                            )}
                          </motion.div>
                        ))}
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>
        {!isRefreshing && (
          <div className="p-4 md:p-6 bg-white ">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white p-4 rounded-xl border border-gray-200 shadow-lg" // Increased shadow
            >
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-gray-800">
                  Today's Room Occupancy
                </h3>
                <div className="flex items-center">
                  <div className="w-3 h-3 rounded-full bg-indigo-500 mr-1"></div>
                  <span className="text-xs text-gray-600">Guest Count</span>
                </div>
              </div>

              <div className="h-72">
                <Bar data={getChartData(chartData)} options={chartOptions} />
              </div>
            </motion.div>
          </div>
        )}
      </div>
      {formToShow === "formA" && (role !== "view only" || isEdit) && (
        <GuestAndCheckInForm
          action={fetchRooms}
          selectedRoomId={selectedRoomId}
          editvalue={editvalue}
          isEdit={isEdit}
          setEditvalue={setEditvalue}
          setisEdit={setisEdit}
          role={role}
        />
      )}

      {formToShow === "formB" && role !== "view only" && (
        <CheckoutModal checkOutData={checkOutData} action={fetchRooms} />
      )}
      {/* {loading && <ExtensionWatcher />}
      {showInactiveModal && <ExtensionModel />} */}
    </div>
  );
};

export default Roomstatus;
{
  /* <div className="flex-grow"></div>
                              <div className="w-full border-t border-white border-opacity-30 my-1"></div>

                              <div className="mt-auto w-full text-center">
                                {room.status === "booked" ? (
                                  <p className="text-lg font-bold text-white">
                                    {room.payableAmount} ₹ /{" "}
                                    {room.todayCheckoutAmount} ₹
                                  </p>
                                ) : (
                                  <p className="text-lg font-bold text-white">
                                    {room.todayCheckoutAmount} ₹
                                  </p>
                                )}
                              </div> */
}
